(() => {
  const root = document.querySelector('[data-team-entry]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = 'true';
  const copy = root.dataset;
  const native = root.querySelector('[data-team-native]');
  const hero = root.querySelector('[data-team-hero]');
  const reveal = root.querySelector('[data-team-reveal]');
  const control = root.querySelector('[data-team-motion]');
  const access = root.querySelector('[data-team-access]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let frame, started, paused = false, introPlayed = false, userEngaged = false;
  const stop = () => { cancelAnimationFrame(frame); hero.classList.remove('is-revealing'); };
  const point = (x, y) => { reveal.style.setProperty('--x', `${x}px`); reveal.style.setProperty('--y', `${y}px`); hero.classList.add('is-revealing'); };
  const tick = time => {
    if (paused || reduced.matches || document.hidden || !root.isConnected) { stop(); return; }
    started ??= time;
    const progress = Math.min((time - started) / 4400, 1);
    const rect = hero.getBoundingClientRect();
    point((1.45 - Math.sin(progress * Math.PI) * 1.1) * rect.width, (.42 + Math.sin(progress * Math.PI * 2) * .18) * rect.height);
    if (progress < 1) frame = requestAnimationFrame(tick); else stop();
  };
  const play = () => { stop(); started = undefined; if (!paused && !reduced.matches) frame = requestAnimationFrame(tick); };
  hero.addEventListener('pointermove', event => {
    if (paused || reduced.matches || event.pointerType !== 'mouse') return;
    cancelAnimationFrame(frame);
    const rect = hero.getBoundingClientRect();
    point(event.clientX - rect.left, event.clientY - rect.top);
  });
  hero.addEventListener('pointerleave', stop);
  access.addEventListener('focusin', () => { userEngaged = true; stop(); });
  access.addEventListener('input', () => { userEngaged = true; stop(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
  reduced.addEventListener('change', stop);
  control.addEventListener('click', () => {
    paused = !paused;
    control.setAttribute('aria-pressed', String(paused));
    control.textContent = paused ? copy.copyPlay : copy.copyPause;
    if (paused) stop(); else play();
  });
  const enhance = () => {
    // Work only with Locksmith's actual passcode form. Never recreate a form,
    // read/store its value, prevent submit or make an access decision here.
    const input = native.querySelector('form.locksmith-resource-form input.locksmith-passcode[name="passcode"]');
    const form = input?.form;
    const submit = form?.querySelector('#locksmith_passcode_submit');
    if (!input || !submit) return;
    observer.disconnect();
    if (!input.dataset.teamStyled) {
      input.dataset.teamStyled = 'true';
      input.type = 'password';
      input.autocomplete = 'off';
      input.required = true;
      input.placeholder = copy.copyPlaceholder;
      input.removeAttribute('autofocus');
      const label = form.querySelector('label[for="locksmith_passcode"]');
      if (label) label.textContent = copy.copyFieldLabel;
      const field = document.createElement('div');
      field.className = 'bs-team-entry__field';
      input.before(field);
      field.append(input);
      const show = document.createElement('button');
      show.type = 'button';
      show.className = 'bs-team-entry__show';
      show.textContent = copy.copyShow;
      show.setAttribute('aria-controls', input.id);
      show.setAttribute('aria-pressed', 'false');
      show.addEventListener('click', () => {
        const visible = input.type === 'password';
        input.type = visible ? 'text' : 'password';
        show.textContent = visible ? copy.copyHide : copy.copyShow;
        show.setAttribute('aria-pressed', String(visible));
      });
      field.append(show);
      const help = document.createElement('p');
      help.className = 'bs-team-entry__help';
      help.id = 'bs-team-entry-help';
      help.textContent = copy.copyHelp;
      const fieldParagraph = field.closest('p');
      (fieldParagraph || field).after(help);
      input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'), help.id].filter(Boolean).join(' '));
      const defaultText = submit.querySelector('.default');
      if (defaultText) defaultText.textContent = copy.copyEnter;
      const loadingText = submit.querySelector('.loading');
      if (loadingText) loadingText.textContent = copy.copyOpening;
      form.addEventListener('submit', stop);
    }
    if (input.classList.contains('failed')) {
      input.setAttribute('aria-invalid', 'true');
      if (!form.querySelector('.bs-team-entry__error')) {
        const error = document.createElement('p');
        error.className = 'bs-team-entry__error';
        error.id = 'bs-team-entry-error';
        error.setAttribute('role', 'alert');
        error.textContent = copy.copyError;
        submit.closest('p').before(error);
        input.setAttribute('aria-describedby', `${input.getAttribute('aria-describedby')} ${error.id}`);
      }
    }
    for (const element of root.querySelectorAll('[data-team-hero],[data-team-intro],[data-team-support]')) element.hidden = false;
    access.setAttribute('aria-labelledby', 'bs-team-entry-title');
    root.classList.add('is-ready');
    if (!introPlayed) {
      introPlayed = true;
      const start = () => { if (!userEngaged) play(); };
      if (reveal.complete) start(); else reveal.addEventListener('load', start, { once: true });
    }
    observer.observe(native, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };
  const observer = new MutationObserver(enhance);
  observer.observe(native, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  enhance();
})();
